function SearchCustomerData() {
  return {
    url: ""
  }
}

export { SearchCustomerData };
